import gql from "graphql-tag";

export interface SteamItemLookup {
  _id: string;
  image?: string;
  rarityColor?: string;
}

// Картинки и редкость скинов по названиям (_id в steamItemModel) — одним запросом.
// Ненайденные названия возвращаются с null, чтобы не запрашивать их повторно
export async function fetchSteamItems(
  apollo: any,
  names: string[]
): Promise<Record<string, SteamItemLookup | null>> {
  const { data } = await apollo.query({
    query: gql`
      query getModelDocs($condition: JSON, $modelName: String!, $opts: JSON) {
        getModelDocs(
          condition: $condition
          modelName: $modelName
          opts: $opts
        ) {
          docs
        }
      }
    `,
    variables: {
      modelName: "steamItemModel",
      condition: { _id: { $in: names } },
      opts: { limit: names.length, select: "_id image rarityColor" }
    },
    fetchPolicy: "no-cache"
  });

  const items: Record<string, SteamItemLookup | null> = {};
  names.forEach(name => (items[name] = null));
  ((data && data.getModelDocs && data.getModelDocs.docs) || []).forEach(
    (item: SteamItemLookup) => (items[item._id] = item)
  );
  return items;
}
